export default __webpack_public_path__ + "static/media/gilletteLogo.120c98ce.png";